import React from 'react';
import { Layout, HeaderDescription } from '../../v2/components/common';
import { Table } from '../../v2/components/hover-reports';
import { GettingStarted } from '../../v2/components/pricing';

const HoverReports: React.FC = () => (
  <Layout title="Hover reports">
    <HeaderDescription
      maxW="1248px"
      py={{ base: 700, tablet: '88px' }}
      mb={300}
      heading="Measurements Overview"
      body="HOVER delivers the most detailed and accurate measurements within the
      industry. Here’s an overview of all the information that is included in
      our Measurements Reports."
      headingProps={{
        fontWeight: { base: 700, desktop: 700 },
        size: { base: 600, tablet: 700, desktop: 800 },
        as: 'h1',
      }}
    />
    <Table />
    <GettingStarted />
  </Layout>
);

export default HoverReports;
